import { DonationHeader } from './DonationHeader';
import { QuickDonationForm } from './QuickDonationForm';
import { PackageList } from './PackageList';
import { DonationFooter } from './DonationFooter';
import { AlternativePaymentButtons } from './AlternativePaymentButtons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

const Home = () => {
  return (
    <div className="d-flex flex-column min-vh-100 ">
      <DonationHeader />

      <main className="flex-1 d-flex flex-column container">
        <div className="mt-4">
          <AlternativePaymentButtons />
          <h3 className="text-black text-left pt-3 mb-3">
            <FontAwesomeIcon
              icon="fa-solid fa-hand-holding-heart"
              className="text-danger me-2 text-body-2"
            />
            Quick Donation
          </h3>
          <QuickDonationForm />
        </div>
        <div className="flex-1  py-6 ">
          <PackageList />
        </div>
      </main>

      <DonationFooter />
    </div>
  );
};

export default Home;
